import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import { testimonialList } from "../../constants/data";

const Testimonial = () => {
  const [page, setPage] = useState(0);
  const [direction, setDirection] = useState(1); // 1 for next, -1 for prev
  const wrapperRef = useRef();
  const { t } = useTranslation();

  const handleChangePage = (newPage) => {
    // console.log('fsdlkf')
    if (newPage === page) return;
    setDirection(newPage > page ? 1 : -1);
    setPage((prev) => (newPage + testimonialList.length) % testimonialList.length);
  };

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const tl = gsap.timeline();

    tl.fromTo(
      el,
      { x: direction * 100, opacity: 0 },
      { x: 0, opacity: 1, duration: 0.5, ease: "power2.out" }
    );

    return () => {
      // Always check if `el` still exists
      if (el) gsap.set(el, { clearProps: "all" });
    };
  }, [page]);

  return (
    <section className="relative py-16 add-square-bg overflow-hidden">
      <ShapeOne />
      <ShapeTwo />
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2 className="text-3xl text-gray-800 mb-4">
          {t('common.thisWord')} <br />
          <span className="text-blue-600"> {t('common.whatClientsSay')} .</span>
        </h2>

        <div className="mt-12 relative flex flex-col justify-between md:h-[450px]">
          {/* Controls */}
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={() => handleChangePage((page - 1 + testimonialList.length) % testimonialList.length)}
              className="text-blue-600 hover:text-blue-800 transition px-4 py-2 rounded-full bg-white shadow hover:shadow-lg"
            >
              ‹
            </button>
            <button
              onClick={() => handleChangePage((page + 1) % testimonialList.length)}
              className="text-blue-600 hover:text-blue-800 transition px-4 py-2 rounded-full bg-white shadow hover:shadow-lg"
            >
              ›
            </button>
          </div>

          {/* Animated container */}
          <div
            ref={wrapperRef}
            className="grid grid-cols-1 md:grid-cols-3 gap-6"
          >
            {testimonialList[page].map((testimonial, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all">
                <div className="flex items-center mb-4 gap-5">
                  <img
                    src={testimonial.img?.startsWith('http')
                      ? testimonial.img
                      : require(`../../assets/images/testimonials/${testimonial.img}`)}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className="text-left">
                    <h5 className="font-semibold text-gray-900">{testimonial.name}</h5>
                    <p className="text-sm text-gray-500">{testimonial.position}</p>
                  </div>
                </div>
                <p className="text-sm text-gray-700">{t(`testimonialSection.${testimonial.translateKeys.content}`)}</p>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="mt-8 flex justify-center items-end gap-2 ">
            {testimonialList.map((_, idx) => (
              <button
                key={idx}
                onClick={() => handleChangePage(idx)}
                className={`w-3 h-3 rounded-full transition ${
                  idx === page ? "bg-blue-600" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}


function ShapeOne() {
  return (
    <svg
      className="absolute bottom-0 left-0 -z-10"
      width="404"
      height="572"
      viewBox="0 0 404 572"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="118"
        cy="286"
        r="265.5"
        stroke="#4175DF"
        strokeOpacity="0.2"
        strokeWidth="41"
      />
    </svg>
  );
}

function ShapeTwo() {
  return (
    <svg
      className="absolute top-0 right-0 -z-10"
      width="269"
      height="479"
      viewBox="0 0 269 479"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="239.5"
        cy="239.5"
        r="239.5"
        fill="#0080FF"
        fillOpacity="0.25"
      />
    </svg>
  );
}

export default Testimonial;
